import {createActions} from 'client/framework';

const normalActions = ['SELECT_OPTION'];

const fillInTheBlankQuestionActions = createActions(null, normalActions);
export default fillInTheBlankQuestionActions;
